import './balances.scss';
import { FC } from 'react';
import { Skeleton } from 'antd';
import { BalancesProps } from '../../../../../core/domain/overview/balances';
import { digitSperator } from '../../../../../core/utils/decimalExtentions';
import { ReactComponent as PMIcon } from 'assets/icons/overview/PM.svg';
import { ReactComponent as USDTIcon } from 'assets/icons/overview/USDT.svg';

interface Props {
    balancesData: BalancesProps;
    balancesLoading: boolean;
}

/** موجودی تتر و یو ووچر حداکثر با دو رقم اعشار نمایش داده می‌شود. */
const formatBalance = (value: number) => {
    if (value === null || value === undefined || Number.isNaN(Number(value))) return '—';
    return digitSperator(Math.round(Number(value) * 100) / 100);
};

export const Balances: FC<Props> = ({ balancesData, balancesLoading }) => {
    const cards = [
        {
            key: 'usdt-bep20',
            label: 'موجودی تتر (BEP20)',
            unit: 'USDT',
            icon: <USDTIcon />,
            accent: 'gold',
            value: balancesData?.usdtBep20Balance,
        },
        {
            key: 'usdt-trc20',
            label: 'موجودی تتر (TRC20)',
            unit: 'USDT',
            icon: <USDTIcon />,
            accent: 'red',
            value: balancesData?.usdtTrc20Balance,
        },
        {
            key: 'uusd',
            label: 'موجودی یو ووچر',
            unit: 'UUSD',
            icon: <PMIcon />,
            accent: 'purple',
            value: balancesData?.uusdBalance,
        },
    ];

    return (
        <div className="pmx-balances">
            {cards.map((card) => (
                <div className={`balance-card accent-${card.accent}`} key={card.key}>
                    <div className="head">
                        <span className="icon">{card.icon}</span>
                        <span className="label">{card.label}</span>
                    </div>
                    <div className="value">
                        {balancesLoading && card.value === undefined ? (
                            <Skeleton.Input active size="small" style={{ width: 140 }} />
                        ) : (
                            <>
                                <b>{formatBalance(card.value)}</b>
                                <span className="unit">{card.unit}</span>
                            </>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
};
